import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-search.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const SearchIcon = createSvgIcon(<Icon />, 'SearchIcon');
